import React from "react";
import FadeSection from "./utils/anim";
import axios from 'axios';
import { faSpinner, faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ContactUs({ lightMode }){
    const [allFormData, setAllFormData] = React.useState({ fname: '',  lname: '',  email: '',  phone: '', message: '' });
    const [isLoading, setIsLoading] = React.useState(false);
    const [termsChecked, setTermsChecked] = React.useState(false);
    const [status, setStatus] = React.useState({message: '', type:'', icon:''});
    const [errors, setErrors] = React.useState({fname: '',  email: '',  phone: ''});

 //   const validation = () => {
     //   const errors = {};

   // }

    const handleFieldChange = (e) => {
        const {name, value} = e.target;
        setAllFormData({...allFormData, [name]: value});
       
    }

    const validate = () =>{
        let errorState = {fname: '',  email: '',  phone: ''};

        let formValid = true;

        if (!allFormData.phone) {
            errorState.phone = "Phone is required";
            formValid = false;
        }
        
        if(!allFormData.fname){ 
            errorState.fname = "First name is required";
            formValid = false;
        }

        if (!allFormData.email) {
            errorState.email = "Email is required";
            //console.log("email no");
            formValid = false;
          } else if (!/\S+@\S+\.\S+/.test(allFormData.email)) {
            errorState.email = "Email is invalid";
            formValid = false;
        }
        setErrors(errorState);

        return formValid;
    }

    const handlesubmit = async (el) =>{
        el.preventDefault();       
       // const contactData = {fname, lname, phone, email, message};
        if(validate()){
            setIsLoading(true);
        try{
            const reponse = await axios.post(process.env.REACT_APP_API_LINK+'/send-contact-mail',allFormData);
            setIsLoading(false);
            if(reponse.status === 200){
                setStatus({message:"Email Sent Successfully", type:'success', icon:(<FontAwesomeIcon className=" w-6 h-6 text-green-500" icon={faCheckCircle} />) });
            } else if (reponse.status === 500){
                
                setStatus({message:"Something went wrong, Please try again", type:'error', icon:(<FontAwesomeIcon className=" w-6 h-6 text-green-500" icon={faExclamationCircle} />) });
            }
            resetData();            
        }catch (error){
            setIsLoading(false);
            setStatus({message:"Email Not Send", type:"error", icon:(<FontAwesomeIcon className=" w-6 h-6 text-green-500" icon={faExclamationCircle} />)});
            resetData();
        }

        setTimeout(() =>{
            setStatus({message:"",type:"",icon:""});
        },3000);
    }
    };

    const resetData = () =>{
        setAllFormData({ fname: '',  lname: '',  email: '',  phone: '',message: '' });
        setErrors({ fname: '',  email: '',  phone: '' });
        setTermsChecked(prev => !prev);
    }

    return(
        <>
        <div className={`contact_us min-h-screen ${lightMode ? "custom-contact-bg-light": "custom-contact-bg"}`}> 
            <div className="max-w-7xl mx-auto">
                <div className="py-10 px-4">
                    <FadeSection effect="fade-right"> 
                        <h2 className={`text-4xl text-left font-bold ${lightMode ? "contact-title-light": "contact-title"} text-white mb-3`}>Contact Me</h2>
                    </FadeSection>
                </div>
                <div className="flex items-center gap-5 flex-col p-4 md:flex-row overflow-hidden">
                    <div className="md:w-2/4 w-full flex items-center min-h-full flex-col">
                        <FadeSection effect="fade-right"> 
                            <h2 className={`text-4xl tracking-wider px-3 md:px-0 ${lightMode ? "text-black font-medium" : "text-white"}`}>Get in touch with me, and i will reach out to you</h2>
                        </FadeSection>
                    </div>
                    <div className="md:w/2/4 flex justify-center">
                        <FadeSection effect="fade-out">
                            <form onSubmit={handlesubmit} className={` backdrop-blur-xl md:p-20 p-10 ${lightMode ? "bg-gray-900 bg-opacity-100" : "bg-white "} bg-opacity-10 rounded-2xl flex flex-col gap-8 z-0 relative`}>
                            {/* <h2 className="text-4xl contact-title-inner text-white">Contact us</h2> */}   
                                <div className=" flex flex-wrap items-center sm:flex-row min-w-full flex-col gap-4 justify-between">
                                {/* <label htmlFor="fname">
                                        <input type="text" id="fname" name="fname" value={fname} onChange={(e) => setFname(e.target.value)} className="border-0 border-b-2 border-white w-full  bg-transparent caret-[#FC0449] outline-none text-white text-lg font-medium" placeholder="First Name"  />
                                    </label> */}
                                        
                                    <label htmlFor="fname">
                                        <input type="text" id="fname" name="fname" value={allFormData.fname} onChange={handleFieldChange} className="border-0 border-b-2 border-white w-full  bg-transparent caret-[#FC0449] outline-none text-white text-lg font-medium" placeholder="First Name *"  />
                                        {errors.fname && (<span className="text-red-700 block font-bold" >{errors.fname}</span>)}
                                    </label>
                                    
                                    <label htmlFor="lname">
                                        <input type="text" id="lname" name="lname" value={allFormData.lname} onChange={handleFieldChange} className="border-0 border-b-2 border-white  bg-transparent caret-[#FC0449] outline-none text-white text-lg font-medium" placeholder="Last Name" />
                                    </label>
                                </div>
                                <div className="gap-4 flex sm:flex-row min-w-full flex-col justify-between">
                                    <label htmlFor="email">
                                        <input type="email" id="email" name="email" value={allFormData.email} onChange={handleFieldChange} className="border-0 border-b-2 border-white  bg-transparent caret-[#FC0449] outline-none text-white text-lg font-medium" placeholder="Email Address *" />
                                        {errors.email && (<span className="text-red-700 block font-bold" >{errors.email}</span>)}
                                    </label>
                                    <label htmlFor="phonenumber">
                                        <input type="text" id="phonenumber" name="phone" value={allFormData.phone} onChange={handleFieldChange} className="border-0 border-b-2 border-white  bg-transparent caret-[#FC0449] outline-none text-white text-lg font-medium" step="1" placeholder="Mobile number *" />
                                        {errors.phone && (<span className="text-red-700 block font-bold" >{errors.phone}</span>)}
                                    </label>
                                </div>
                                <div className="min-w-full">
                                    <label htmlFor="message">
                                        <textarea value={allFormData.message} onChange={handleFieldChange} className="w-full border-0 border-b-2 border-white bg-transparent outline-none caret-[#FC0449] text-white text-lg font-medium" name="message" id="message" placeholder="Enter your message" />
                                    </label>
                                </div>
                                <div className="gap-4 flex justify-between ">
                                    <input name="terms" checked={termsChecked} onChange={() => setTermsChecked(prev => !prev)} type="checkbox" className="required:border-red-500 hover:cursor-pointer checked:bg-blue-500" required={true}/> 
                                    <p className="text-white text-left">By clicking, I accept to agree the terms of processing my personal info</p>
                                </div>
                                <button type="submit" className={`${isLoading ? 'pointer-events-none':''} third-color-bg md:w-1/3 w-2/4 text-white px-2 py-2 rounded-3xl !mt-3 group transition-all duration-300 items-center gap-2`}>Send Message {isLoading && (<FontAwesomeIcon className="animate-spin" icon={faSpinner} />) }</button>
                                
                                {status.message && (<div className={`border-2 ${status.type === "success" ? 'border-green-500 bg-green-100':'border-red-500 bg-red-100'} border-solid p-1 rounded-full text-black `}>
                                    
                                    <div className="flex items-center space-x-3">
                                        <div className={` w-10 h-10 rounded-full ${status.type === "success" ? 'bg-green-200':'bg-red-200' }  flex items-center justify-center`}>
                                            <FontAwesomeIcon className={` w-6 h-6 ${status.type === "success" ? 'text-green-500':'text-red-500' } `} icon={faCheckCircle} />
                                        </div>
                                        <div className="flex-0">
                                            <h3 className="font-semibold text-gray-900">{status.message}</h3>
                                        </div>
                                    </div>
                                </div>)
                                }   
                            </form>
                        </FadeSection>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default ContactUs;